import React, { useState } from 'react';
import styles from './UserAssigneeSelector.module.scss';
import { Input } from '../Input/Input';
import { Button } from '../Button/Button';

export interface User {
  id: string;
  name: string;
  avatarUrl?: string;
}

interface Props {
  users: User[];
  assignedUser?: User | null;
  onAssign: (user: User) => void;
  onUnassign: (user: User) => void;
  isLoading?: boolean;
  placeholder?: string;
}

export const UserAssigneeSelector: React.FC<Props> = ({
  users,
  assignedUser,
  onAssign,
  onUnassign,
  isLoading = false,
  placeholder = 'Buscar usuario...',
}) => {
  const [search, setSearch] = useState('');
  const [showList, setShowList] = useState(false);

  const filtered = users.filter(u =>
    u.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleSelect = (user: User) => {
    onAssign(user);
    setSearch('');
    setShowList(false);
  };

  if (assignedUser) {
    return (
      <div className={styles.chipContainer}>
        <div className={styles.chip}>
          <span className={styles.avatar}>
            {assignedUser.avatarUrl ? (
              <img src={assignedUser.avatarUrl} alt={assignedUser.name} />
            ) : (
              assignedUser.name
                .split(' ')
                .map(n => n[0])
                .join('')
                .toUpperCase()
            )}
          </span>
          <span className={styles.name}>{assignedUser.name}</span>
          <Button
            className={styles.removeBtn}
            onClick={() => onUnassign(assignedUser)}
            aria-label="Eliminar responsable"
            variant="ghost"
          >
            ×
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.selectorContainer}>
      <Input
        label="Buscar usuario"
        value={search}
        onChange={e => {
          setSearch(e.target.value);
          setShowList(true);
        }}
        onFocus={() => setShowList(true)}
        placeholder={placeholder}
        disabled={isLoading}
        className={styles.input}
      />
      {showList && search.length > 0 && (
        <div className={styles.dropdown}>
          {isLoading ? (
            <div className={styles.loading}>Cargando...</div>
          ) : filtered.length > 0 ? (
            filtered.map(user => (
              <button
                key={user.id}
                className={styles.dropdownItem}
                onClick={() => handleSelect(user)}
                type="button"
              >
                <span className={styles.avatarSmall}>
                  {user.avatarUrl ? (
                    <img src={user.avatarUrl} alt={user.name} />
                  ) : (
                    user.name
                      .split(' ')
                      .map(n => n[0])
                      .join('')
                      .toUpperCase()
                  )}
                </span>
                {user.name}
              </button>
            ))
          ) : (
            <div className={styles.noResults}>No hay usuarios que coincidan</div>
          )}
        </div>
      )}
    </div>
  );
}; 